<template>
	<div v-if="statistics">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-statistic group-separator="," :precision="2"
					:value="statistics.remainamount?parseFloat(statistics.remainamount):0" title="未开票金额"></el-statistic>
			</el-col>
			<el-col :span="6">
				<el-statistic group-separator="," :precision="2"
					:value="statistics.unauditamount?parseFloat(statistics.unauditamount):0"
					title="待审核金额"></el-statistic>
			</el-col>
			<el-col :span="6">
				<el-statistic group-separator="," :precision="2"
					:value="statistics.haswriteoffamount?parseFloat(statistics.haswriteoffamount):0"
					title="已开票金额"></el-statistic>
			</el-col>
		</el-row>
	</div>
</template>
<style>

</style>

<script>
	export default {
		name: '',
		props: {
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				statistics: null,
			}
		},
		watch: {

		},
		mounted() {
			this.init()
		},
		computed: {

		},
		methods: {
			init() {
				this.$api.paymentapplicationinvoice.statistics().then((res) => {
					this.statistics = res
				})
			}
		},
		components: {

		}
	}
</script>